import React from 'react';
import { Link } from 'react-router-dom';
import { usePreferences } from '../contexts/PreferencesContext';
import WeeklyDays from './WeeklyDays';

interface CalorieWidgetProps {
  totalCalories: number;
  mealCount: number;
  loading?: boolean;
  error?: string | null;
}

const CalorieWidget: React.FC<CalorieWidgetProps> = ({ 
  totalCalories, 
  mealCount, 
  loading = false, 
  error = null 
}) => {
  const { preferences } = usePreferences();
  const target = preferences.dailyCalorieTarget;
  const percentage = Math.min((totalCalories / target) * 100, 100);
  const isOverTarget = totalCalories > target;

  if (loading) {
    return (
      <div className="calorie-widget">
        <div className="loading-inline">
          <div className="loading-spinner-small"></div>
          <span>Loading calories...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="calorie-widget">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="calorie-widget">
      <Link 
        to={`/history?date=${new Date().toISOString().split('T')[0]}`} 
        className="calorie-widget-main"
      >
        <div className="calorie-widget-header">
          <h3>Today's Calories</h3>
          <span className="meal-count">{mealCount} meals</span>
        </div>
        
        <div className="calorie-progress-container">
          <div className="calorie-circle">
            <svg className="progress-ring" width="180" height="180">
              <circle
                className="progress-ring-background"
                stroke="#e8eced"
                strokeWidth="8"
                fill="transparent"
                r="82"
                cx="90"
                cy="90"
              />
              <circle
                className={`progress-ring-progress ${isOverTarget ? 'over-target' : 'under-target'}`}
                stroke={isOverTarget ? '#dc3545' : '#28a745'}
                strokeWidth="8"
                fill="transparent"
                r="82"
                cx="90"
                cy="90"
                strokeDasharray={`${2 * Math.PI * 82}`}
                strokeDashoffset={`${2 * Math.PI * 82 * (1 - percentage / 100)}`}
              />
            </svg>
            <div className="calorie-circle-content">
              <span className={`calorie-number ${isOverTarget ? 'over-target' : 'under-target'}`}>
                {totalCalories}
              </span>
              <span className="calorie-target">/ {target}</span>
            </div>
          </div>
        </div>
      </Link>
      
      <div className="weekly-section">
        <h4>This Week</h4>
        <WeeklyDays />
      </div>
    </div>
  );
};

export default CalorieWidget;